import I18n from "./I18n"

export default class Modal {
  static confirm(bus, text, yesLabel, noLabel) {
    if (yesLabel === undefined) {
      yesLabel = I18n.$t('Oui')
    }
    if (noLabel === undefined) {
      noLabel = I18n.$t('Non')
    }
    return new Promise((resolve, reject) => {
      bus.emit('confirm', {
        text, yesLabel, noLabel, resolve
      })
    })
  }
}
